var _path, _path2, _rect, _rect2, _rect3, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMassnahmen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.26395 7.73334C8.20854 7.78874 8.11928 7.79049 8.06174 7.73732L7.17779 6.92045C6.52061 6.31314 5.50111 6.33324 4.86837 6.96598C4.20899 7.62536 4.21896 8.69745 4.89049 9.34446L7.43827 11.7992C7.84167 12.1879 8.48202 12.182 8.87816 11.7859L13.8329 6.83206C14.4773 6.18773 14.4774 5.14295 13.833 4.49857C13.1887 3.85428 12.1441 3.85421 11.4998 4.49841L8.26395 7.73334Z",
    fill: "#CED3DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.26395 19.4013C8.20854 19.4567 8.11928 19.4585 8.06174 19.4053L7.17779 18.5884C6.52061 17.9811 5.50111 18.0012 4.86837 18.6339C4.20899 19.2933 4.21896 20.3654 4.89049 21.0124L7.43827 23.4672C7.84167 23.8559 8.48202 23.8499 8.87816 23.4539L13.8329 18.5C14.4773 17.8557 14.4774 16.8109 13.833 16.1665C13.1887 15.5223 12.1441 15.5222 11.4998 16.1664L8.26395 19.4013Z",
    fill: "#CED3DC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.666,
    y: 6.66602,
    width: 20,
    height: 3.33333,
    rx: 1.66667,
    fill: "#CED3DC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.666,
    y: 18.334,
    width: 20,
    height: 3.33333,
    rx: 1.66667,
    fill: "#CED3DC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.666,
    y: 30.002,
    width: 20,
    height: 3.33333,
    rx: 1.66667,
    fill: "#CED3DC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66732 29.9993V33.3327H10.0007V29.9993H6.66732ZM5.00065 26.666C4.08018 26.666 3.33398 27.4122 3.33398 28.3327V34.9993C3.33398 35.9198 4.08018 36.666 5.00065 36.666H11.6673C12.5878 36.666 13.334 35.9198 13.334 34.9993V28.3327C13.334 27.4122 12.5878 26.666 11.6673 26.666H5.00065Z",
    fill: "#CED3DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMassnahmen);
export default __webpack_public_path__ + "static/media/IconMassnahmen.acac84ccc450e8121e753843c6093585.svg";
export { ForwardRef as ReactComponent };